import { AppState } from '../reducers';
import { AuthState } from './auth.reducers';

export const selectAuthState = (state: AppState): AuthState => state.auth;
